
<app-navbar-style-two></app-navbar-style-two>

<section class="responsive-products-section">

    <div class="container">

        <!-- Section Title -->
        <div class="section-title" *ngFor="let Content of sectionTitle">
            <h2>{{Content.title}}</h2>
        </div>

        <!-- Products Carousel -->
        <div class="products-slides"
             *ngIf="singleProductsItem.length > 0">

            <owl-carousel-o [options]="productsSlidesOptions">

                <ng-template carouselSlide
                             *ngFor="let Content of singleProductsItem">

                    <div class="product-slide-wrapper">

                        <div class="single-products-item">

                            <!-- Product Image -->
                            <div class="products-image">

                                <a [routerLink]="['/product', Content.keywords]"
                                   class="d-block">

                                    <img [src]="Content.mainImg"
                                         [alt]="Content.title"
                                         loading="lazy">

                                </a>

                                <!-- Product Buttons -->
                                <ul class="products-button">

                                    <li>
                                        <a [routerLink]="['/product', Content.keywords]">
                                            <i class="bx bx-show-alt"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a [href]="Content.mainImg"
                                           class="popup-btn">
                                            <i class="bx bx-scan"></i>
                                        </a>
                                    </li>

                                    <li>
                                        <a [routerLink]="['/product', Content.keywords]">
                                            <i class="bx bx-link"></i>
                                        </a>
                                    </li>

                                </ul>

                            </div>

                            <!-- Product Details -->
                            <div class="products-content">

                                <h3>
                                    <a [routerLink]="['/product', Content.keywords]">
                                        {{Content.title}}
                                    </a>
                                </h3>

                                <div class="price">

                                    <span class="new-price">
                                        {{Content.newPrice}}
                                    </span>

                                    <span class="old-price"
                                          *ngIf="Content.oldPrice">
                                        {{Content.oldPrice}}
                                    </span>

                                </div>

                            </div>

                            <!-- Sale -->
                            <span class="on-sale"
                                  *ngIf="Content.sale">
                                {{Content.sale}}
                            </span>

                            <!-- Stock -->
                            <div class="out-of-stock"
                                 *ngIf="Content.outOfStock">
                                {{Content.outOfStock}}
                            </div>

                        </div>

                    </div>

                </ng-template>

            </owl-carousel-o>

        </div>

        <!-- No Results -->
        <div class="no-results-found"
             *ngIf="singleProductsItem.length === 0">

            No results found.

        </div>

    </div>

</section>
